import { fold, sort, isEmpty, ofArray, append, truncate, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { getCallsByDateUrl, getNonInvoicedCallsUrl, BearerTypeModule_toString, TrafficChoiceModule_fromString, getSummary, TrafficChoiceModule_toTranslation, TrafficChoice, TrafficChoiceModule_toString } from "./Model.js";
import { addMonths, create } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { uncurry, compare, lazyFromValue } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { IsoCountryCode$reflection } from "../../DomainTypes.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { loadEffect, LoadState$2, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { loadCallsByDate as loadCallsByDate_1, loadMonthsWithTraffic as loadMonthsWithTraffic_1, loadNonInvoicedTraffic as loadNonInvoicedTraffic_1 } from "./Api.js";
import { logw, classNames, decimalToTwoDecimals, logwi, Byte_ToString_Z3EC7497, Byte_ToStringTrafficReport_Z3EC7497, String_toLowerCase, DateTimeExtensions_to1stInMonth } from "../../Utils.js";
import { MaterialIcon_render_Z384F8060, dotsLoading } from "../../ViewUtils.js";
import { info, error } from "../../Components/Message/Message.js";
import { SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { renderTable } from "../../Components/Table/Table.js";
import { hours, minutes, seconds, days, create as create_1 } from "../../fable_modules/fable-library.3.7.20/TimeSpan.js";
import { toString, toInt } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { ValidatedUrl__get_Value } from "../../HttpV2.js";
import { ButtonProps, defaultProps, main } from "../../Components/Button/Button.js";
import "../../../src/Containers/Traffic/View.scss";


function getTrafficSelectOptions(getTranslation, monthsWithTraffic) {
    const monthsBack = map((date) => [TrafficChoiceModule_toString(new TrafficChoice(2, date)), TrafficChoiceModule_toTranslation(getTranslation, new TrafficChoice(2, date))], map((yearMonth) => create(yearMonth.Year, yearMonth.Month, 1, 8, 0, 0), truncate(5, monthsWithTraffic)));
    return lazyFromValue(append(ofArray([[TrafficChoiceModule_toString(new TrafficChoice(0)), TrafficChoiceModule_toTranslation(getTranslation, new TrafficChoice(0))], [TrafficChoiceModule_toString(new TrafficChoice(1)), TrafficChoiceModule_toTranslation(getTranslation, new TrafficChoice(1))]]), monthsBack));
}

export class TrafficProps extends Record {
    constructor(ClientNr, ContractNr, CountryCode, ByteFormat) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractNr = (ContractNr | 0);
        this.CountryCode = CountryCode;
        this.ByteFormat = (ByteFormat | 0);
    }
}

export function TrafficProps$reflection() {
    return record_type("Containers.Traffic.View.TrafficProps", [], TrafficProps, () => [["ClientNr", int32_type], ["ContractNr", int32_type], ["CountryCode", IsoCountryCode$reflection()], ["ByteFormat", int32_type]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, children_10, children_8;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const trafficChoiceState = react.useState(new TrafficChoice(1));
    const monthsWithTrafficState = react.useState(new LoadState$2(0));
    const callsByDateState = react.useState(new LoadState$2(0));
    const callsByDateSummary = react.useMemo(() => {
        const matchValue = callsByDateState[0];
        switch (matchValue.tag) {
            case 1: {
                return new LoadState$2(1);
            }
            case 3: {
                return new LoadState$2(3, matchValue.fields[0]);
            }
            case 2: {
                return new LoadState$2(2, getSummary(matchValue.fields[0].Result));
            }
            default: {
                return new LoadState$2(0);
            }
        }
    }, [callsByDateState[0]]);
    const loadNonInvoicedTraffic = (toSlk_1) => {
        loadEffect(() => loadNonInvoicedTraffic_1(props.ClientNr, props.ContractNr, toSlk_1), (arg_2) => {
            callsByDateState[1](arg_2);
        });
    };
    react.useEffect(() => {
        loadEffect(() => loadMonthsWithTraffic_1(props.ClientNr, props.ContractNr), (arg) => {
            monthsWithTrafficState[1](arg);
        });
        loadNonInvoicedTraffic(false);
    }, [props.ClientNr, props.ContractNr, props.CountryCode]);
    react.useEffect(() => {
        const matchValue_1 = trafficChoiceState[0];
        switch (matchValue_1.tag) {
            case 1: {
                loadNonInvoicedTraffic(false);
                break;
            }
            case 2: {
                const date = matchValue_1.fields[0];
                const dateTo = DateTimeExtensions_to1stInMonth(addMonths(date, 1));
                const dateFrom = DateTimeExtensions_to1stInMonth(date);
                loadEffect(() => loadCallsByDate_1(props.ClientNr, props.ContractNr, dateFrom, dateTo, false), (arg_1) => {
                    callsByDateState[1](arg_1);
                });
                break;
            }
            default: {
            }
        }
    }, [trafficChoiceState[0]]);
    let trafficChoiceHtml;
    const matchValue_2 = monthsWithTrafficState[0];
    switch (matchValue_2.tag) {
        case 1: {
            trafficChoiceHtml = dotsLoading;
            break;
        }
        case 3: {
            trafficChoiceHtml = error(matchValue_2.fields[0].split(""));
            break;
        }
        case 2: {
            trafficChoiceHtml = selectOption((inputRecord = SelectOption_get_getDefault(), new SelectOption(new ValueProp(0, TrafficChoiceModule_toString(trafficChoiceState[0]), (e) => {
                const arg_3 = TrafficChoiceModule_fromString(Browser_Types_Event__Event_get_Value(e));
                trafficChoiceState[1](arg_3);
            }), "traffic-select-period", getTrafficSelectOptions(getTranslation, matchValue_2.fields[0]).Value, inputRecord.Classes, inputRecord.LabelText, inputRecord.Disabled, inputRecord.HTMLProps)));
            break;
        }
        default: {
            trafficChoiceHtml = react.createElement(react.Fragment, {});
        }
    }
    let summaryHtml;
    if (callsByDateSummary.tag === 1) {
        summaryHtml = dotsLoading;
    }
    else if (callsByDateSummary.tag === 3) {
        summaryHtml = error(callsByDateSummary.fields[0].split(""));
    }
    else if (callsByDateSummary.tag === 2) {
        if (isEmpty(callsByDateSummary.fields[0])) {
            summaryHtml = info((getTranslation("CustomerContract.Invoicee.Subscriptions.Traffic.NoTrafficFound") + ".").split(""));
        }
        else {
            const sortedSummaryRows = sort(callsByDateSummary.fields[0], {
                Compare: compare,
            });
            summaryHtml = renderTable(ofArray([getTranslation("CustomerContract.Invoicee.Subscriptions.Traffic.BearerType"), getTranslation("CustomerContract.Invoicee.Subscriptions.Traffic.Amount"), getTranslation("CustomerContract.Invoicee.Subscriptions.Traffic.PriceExcVAT")]), map((row) => {
                let units_1, bearerType, time, daysTranslation, matchValue_3, daysStr, arg_4, arg_9, arg_8, arg_7, matchValue_4;
                return ofArray([BearerTypeModule_toString(row.BearerType), (units_1 = row.Units, (bearerType = (row.BearerType | 0), (bearerType === 0) ? ((time = create_1(0, 0, ~(~toInt(units_1))), (daysTranslation = String_toLowerCase((matchValue_3 = (days(time) | 0), (matchValue_3 === 0) ? "" : ((matchValue_3 === 1) ? getTranslation("Common.Day") : getTranslation("Common.Days")))), (daysStr = ((days(time) === 0) ? "" : ((arg_4 = (days(time) | 0), toText(printf("%i %s "))(arg_4)(daysTranslation)))), (arg_9 = (seconds(time) | 0), (arg_8 = (minutes(time) | 0), (arg_7 = (hours(time) | 0), toText(printf("%s%ih %im %is"))(daysStr)(arg_7)(arg_8)(arg_9)))))))) : ((bearerType === 1) ? ((time = create_1(0, 0, ~(~toInt(units_1))), (daysTranslation = String_toLowerCase((matchValue_3 = (days(time) | 0), (matchValue_3 === 0) ? "" : ((matchValue_3 === 1) ? getTranslation("Common.Day") : getTranslation("Common.Days")))), (daysStr = ((days(time) === 0) ? "" : ((arg_4 = (days(time) | 0), toText(printf("%i %s "))(arg_4)(daysTranslation)))), (arg_9 = (seconds(time) | 0), (arg_8 = (minutes(time) | 0), (arg_7 = (hours(time) | 0), toText(printf("%s%ih %im %is"))(daysStr)(arg_7)(arg_8)(arg_9)))))))) : ((bearerType === 2) ? ((time = create_1(0, 0, ~(~toInt(units_1))), (daysTranslation = String_toLowerCase((matchValue_3 = (days(time) | 0), (matchValue_3 === 0) ? "" : ((matchValue_3 === 1) ? getTranslation("Common.Day") : getTranslation("Common.Days")))), (daysStr = ((days(time) === 0) ? "" : ((arg_4 = (days(time) | 0), toText(printf("%i %s "))(arg_4)(daysTranslation)))), (arg_9 = (seconds(time) | 0), (arg_8 = (minutes(time) | 0), (arg_7 = (hours(time) | 0), toText(printf("%s%ih %im %is"))(daysStr)(arg_7)(arg_8)(arg_9)))))))) : ((bearerType === 11) ? ((matchValue_4 = (props.ByteFormat | 0), (matchValue_4 === 1000) ? Byte_ToStringTrafficReport_Z3EC7497(units_1) : ((matchValue_4 === 1024) ? Byte_ToString_Z3EC7497(units_1) : ((logwi(toText(printf("[TrafficReport - Summary] Unexpected byte format: %i"))(matchValue_4)), Byte_ToString_Z3EC7497(units_1)))))) : toString(units_1)))))), decimalToTwoDecimals(row.Price)]);
            }, sortedSummaryRows));
        }
    }
    else {
        summaryHtml = react.createElement(react.Fragment, {});
    }
    const downloadButtonClasses = classNames(ofArray([["fit-content", true], ["text-decoration-none", true], ["invisible", (callsByDateSummary.tag === 2) ? (isEmpty(callsByDateSummary.fields[0])) : true]]));
    let downloadLink;
    const matchValue_5 = trafficChoiceState[0];
    switch (matchValue_5.tag) {
        case 1: {
            const urlResult = getNonInvoicedCallsUrl(props.ClientNr, props.ContractNr, true);
            if (urlResult.tag === 1) {
                logw(urlResult.fields[0]);
                downloadLink = "";
            }
            else {
                downloadLink = ValidatedUrl__get_Value(urlResult.fields[0]);
            }
            break;
        }
        case 2: {
            const date_2 = matchValue_5.fields[0];
            const urlResult_1 = getCallsByDateUrl(props.ClientNr, props.ContractNr, DateTimeExtensions_to1stInMonth(date_2), DateTimeExtensions_to1stInMonth(addMonths(date_2, 1)), true);
            if (urlResult_1.tag === 1) {
                logw(urlResult_1.fields[0]);
                downloadLink = "";
            }
            else {
                downloadLink = ValidatedUrl__get_Value(urlResult_1.fields[0]);
            }
            break;
        }
        default: {
            downloadLink = "";
        }
    }
    let byteFormatInfoIconHtml;
    if (callsByDateSummary.tag === 2) {
        const hasDataTraffic = fold((acc, curr) => {
            if (curr.BearerType === 11) {
                return true;
            }
            else {
                return acc;
            }
        }, false, callsByDateSummary.fields[0]);
        if (hasDataTraffic) {
            const children_3 = [MaterialIcon_render_Z384F8060("info", toText(printf("Byte format: %i"))(props.ByteFormat))];
            byteFormatInfoIconHtml = react.createElement("div", {
                className: "ml-2 fit-content",
            }, ...children_3);
        }
        else {
            byteFormatInfoIconHtml = react.createElement(react.Fragment, {});
        }
    }
    else {
        byteFormatInfoIconHtml = react.createElement(react.Fragment, {});
    }
    const children_14 = [(children_10 = [react.createElement("div", {
        className: "traffic__select mr-4",
    }, trafficChoiceHtml), (children_8 = [main(new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Traffic.DownloadToExcel"), defaultProps.Content, (value_3) => {
    }, defaultProps.Disabled, "traffic-download-slk", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement("a", {
        className: downloadButtonClasses,
        href: downloadLink,
        ["data-regression"]: "traffic-download-button",
    }, ...children_8))], react.createElement("div", {
        className: "d-flex",
    }, ...children_10)), react.createElement("div", {
        ["data-regression"]: "traffic-summary",
        className: "d-flex",
    }, summaryHtml, byteFormatInfoIconHtml)];
    return react.createElement("div", {
        id: "traffic-content",
        className: "traffic__content",
    }, ...children_14);
}, "Traffic", uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Traffic\\View.fs", 250);

